<script>
	export let height = '550px';
	export let imagens = [
		'/assets/images/fundos/fundoHomeFolhas.jpg',
		'/assets/images/fundos/fundoHomeIgreja.jpg',
		'/assets/images/fundos/fundoHomeCaracol.jpg',
		'/assets/images/fundos/fundoHomeHortencia.jpg',
		'/assets/images/fundos/fundoHomeNatureza.jpg',
	].reverse();
</script>


<div class="kenburns">
	<div class="crossfade">
		{#each imagens as img}
			<img src="{img}" />
		{/each}
	</div>
	<div class="content"><slot></slot></div>
</div>
<style type="text/sass">
	@import 'public/assets/sass/variables.sass'
.kenburns
	position: relative
	.content
		position: absolute
		left: 0
		top: 0
		width: 100%
.crossfade
	background: #fff
	display: flex
	align-items: flex-end
	height: 550px
	overflow: hidden
	position: relative
	img
		user-select: none
		z-index: 0
		position: absolute
		min-width: 100%
		min-height: 100%
		height: auto
		background: #000
		-webkit-backface-visibility: hidden
		backface-visibility: hidden
		opacity: 0
		left: 50%
		transform: scale(1.4) translateX(-50%)
		-webkit-animation: CrossFade 60s infinite
		animation: CrossFade 50s infinite
		&:nth-child(4)
			-webkit-animation-delay: 10s
			animation-delay: 10s
		&:nth-child(3)
			-webkit-animation-delay: 20s
			animation-delay: 20s
		&:nth-child(2)
			-webkit-animation-delay: 30s
			animation-delay: 30s
		&:nth-child(1)
			-webkit-animation-delay: 40s
			animation-delay: 40s

@-webkit-keyframes CrossFade
	25%
		opacity: 1
		transform: scale(1) translateX(-50%)
	40%
		opacity: 0
@keyframes CrossFade
	25%
		opacity: 1
		transform: scale(1) translateX(-50%)
	40%
		opacity: 0
</style>